/* eslint-disable camelcase */
/* eslint-disable no-use-before-define */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DokanCard from '../card/DokanCard';
import DokanInputField from '../form/DokanInputField';
import DokanIcons from '../icon/DokanIcons';
import { uploadMedia } from '../../utils/requests';
import { handleDownloadable, handleProductInput } from '../../redux/products/productsActions';

function Downloadable() {
    const { downloads, download_limit, download_expiry } = useSelector(
        (state) => state.products.productInputData
    );
    const [formValues, setFormValues] = useState(downloads ?? [{ name: '', file: '' }]);
    const dispatch = useDispatch();
    const handleChange = (index, event, name) => {
        const newFormValues = [...formValues];
        newFormValues[index][name] = event.target.value;
        setFormValues(newFormValues);
    };
    const handleSingleInput = (index = 0, event, name) => {
        dispatch(handleProductInput(name, event.target.value));
    };
    const addFormFields = () => {
        setFormValues([...formValues, { name: '', file: '' }]);
    };
    const removeFormFields = (index) => {
        const updateFormFields = [...formValues];
        updateFormFields.splice(index, 1);
        setFormValues(updateFormFields);
    };
    const handleFileChange = async (e, index) => {
        const fileData = await uploadDownloabableFile(e.target.files[0]);
        const newFormValues = [...formValues];
        console.log(fileData);
        newFormValues[index].name = fileData.slug;
        newFormValues[index].file = fileData.source_url;
        setFormValues(newFormValues);
        dispatch(handleDownloadable(newFormValues));
    };

    const uploadDownloabableFile = async (file) => {
        // upload code here
        const res = await uploadMedia(file);
        return res.data;
    };
    return (
        <>
            <DokanCard
                hasTitle
                hasDivider
                cardTitle="Downloadable Options"
                isOval
                svgIcon="#withdraw"
            >
                <div className="inline-grid grid-flow-col gap-3">
                    <div>
                        <p className="text-base font-bold">Downloadable files</p>
                    </div>
                </div>

                <div className="border border-solid rounded-sm border-gray-300 my-3 p-3">
                    {formValues.map((element, index) => (
                        <div className="flex justify-start gap-5 items-center mt-5" key={index}>
                            <DokanIcons icon="#bar" size={10} />

                            <DokanInputField
                                inputValue={element.name}
                                inputHandle={handleChange}
                                inputName="name"
                                inputIndex={index}
                                inputLabel="File Name"
                            />
                            <DokanInputField
                                inputValue={element.file}
                                inputHandle={handleChange}
                                inputName="file"
                                inputIndex={index}
                                inputLabel="File URL"
                            />
                            <div className="upload-btn-wrapper">
                                <button type="button" className="upload-btn">
                                    <div className="flex justify-center gap-3 items-center">
                                        <div>
                                            <DokanIcons icon="#paper_clip" />
                                        </div>
                                        <div className="font-bold text-white">Choose file</div>
                                    </div>
                                </button>
                                <input
                                    type="file"
                                    name="myfile"
                                    onChange={(e) => handleFileChange(e, index)}
                                />
                            </div>
                            {index ? (
                                <button type="button" onClick={() => removeFormFields(index)}>
                                    <DokanIcons icon="#cross_white" />
                                </button>
                            ) : (
                                <button type="button">
                                    <DokanIcons icon="#paper_clip" />
                                </button>
                            )}
                        </div>
                    ))}

                    <div className="ml-5 mt-5">
                        <button
                            type="button"
                            className="border border-border-matt-blue text-matt-blue px-4 py-2 rounded-sm transition ease-in-out duration-500 transform hover:translate-x-3 hover:scale-100 focus:outline-none"
                            onClick={addFormFields}
                        >
                            {' '}
                            + Add field
                        </button>
                    </div>
                </div>
                <div>
                    <p className="font-bold text-dark py-3">Limit & Expiry</p>
                    <div>
                        <div>
                            <DokanInputField
                                inputValue={download_limit}
                                inputHandle={handleSingleInput}
                                inputName="download_limit"
                                inputIndex=""
                                inputLabel="Download Limit"
                            />
                            <div className="w-11/12 text-tertiary">
                                {`Customers wont be able to downlaod more than ${download_limit} number.`}
                            </div>
                        </div>
                        <div className="mt-3">
                            <DokanInputField
                                inputValue={download_expiry}
                                inputHandle={handleSingleInput}
                                inputName="download_expiry"
                                inputIndex=""
                                inputLabel="Days"
                            />
                            <div className="w-11/12 text-tertiary">
                                Enter the number of days before a download link expires.
                            </div>
                        </div>
                    </div>
                </div>
            </DokanCard>
        </>
    );
}

export default Downloadable;
